import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import isAccessTokenValid from '@app/helpers/isAccessTokenValid'
import isUserLoggedIn from '@app/helpers/isUserLoggedIn'
import { withStyles } from '@app/components/styles'
import { saveActionDescription } from '@app/actions/scenes/currentSceneCreating'
import * as syncNotifications from '@app/actions/notifications/notificationsChannel'
import { isIOS } from 'react-device-detect'
import SelectActionSecurityManagementDevice
  from '@app/components/MyAutomation/Tabs/ScenesScreens/CreateAction/MezzoActions/SelectActionSecurityManagementDevice/SelectActionSecurityManagementDevice'
import SelectActionSecurityManagementDeviceIOS
  from '@app/components/MyAutomation/Tabs/iOS/CreateAction/MezzoActions/SelectActionSecurityManagementDevice/SelectActionSecurityManagementDevice'
import { withAccessDenied, withNotifications, withRouter } from '@app/hocs'

const isWebView = navigator.userAgent.includes('WebView') || navigator.userAgent.includes('wv')
let enhance = isIOS && isWebView ? withStyles(SelectActionSecurityManagementDeviceIOS) : withStyles(SelectActionSecurityManagementDevice)

const mapStateToProps = (state) => {
  const { isMobile } = state.mobileDetector
  const { path } = state.shadowIn
  const { isNCentral } = state.unit
  return {
    isNCentral,
    isMobile,
    path,
    accessDenied: !isAccessTokenValid(state.secrets.accessToken),
    userLoggedIn: (isUserLoggedIn(state.users.currentUser.user.preferredName)),
  }
}

const mapDispatchToProps = (dispatch) => bindActionCreators({
  notifications: syncNotifications.sync,
  saveActionDescription,
}, dispatch)

enhance = withNotifications(enhance)
enhance = withAccessDenied(enhance)
enhance = connect(mapStateToProps, mapDispatchToProps)(enhance)

const SelectActionSecurityManagementDeviceEnhanced = enhance

export default withRouter(SelectActionSecurityManagementDeviceEnhanced)
